import(/* webpackMode: "eager" */ "/var/www/kst-frontend-staging/app/privacy-policy/page.tsx")